var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#8C52FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4626 12.5375C28.4296 13.5045 28.4296 15.0724 27.4626 16.0394L16.43 27.0719C15.8527 27.6492 15.1245 28.0523 14.3288 28.2351L11 29L11.7649 25.6712C11.9477 24.8755 12.3508 24.1474 12.9282 23.57L23.9607 12.5375C24.9278 11.5705 26.4956 11.5705 27.4626 12.5375ZM27.4626 12.5375L29 11M25.1562 22.5314L26.6937 20.9939C27.5429 20.1448 27.5429 18.768 26.6937 17.9189L22.8498 14.0751M13.3062 23.6186L16.3813 26.6937",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenBorder);
export default __webpack_public_path__ + "static/media/pen-border.12321896d3cf40e60c6d38dcf3d9539e.svg";
export { ForwardRef as ReactComponent };